import { render, staticRenderFns } from "./labels.vue?vue&type=template&id=2ec06d74&scoped=true"
import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"
import style0 from "./labels.vue?vue&type=style&index=0&id=2ec06d74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec06d74",
  null
  
)

export default component.exports